/*******************************************************************************
EXPAND A NEWS UPDATE
Expands a news update that is in compact mode.
*******************************************************************************/

export default function expandNewsUpdate(e) {

    // We don't want a click on the player link to take the user to a new page
    if (e.target.tagName.toLowerCase() === 'a') { e.preventDefault(); }

    // Remove the is-compact class to expand the news update and then scroll to it
    const $newsUpdate = $(e.currentTarget);
    $newsUpdate.removeClass('is-compact').addClass('was-user-expanded');
    $newsUpdate.get(0).scrollIntoView({ behavior: 'smooth', block: 'center' });
}
